export const PEDIDO_STATUS_LABELS = {
  rascunho: "Pendente de planejamento",
  planejada: "Em planejamento",
  em_execucao: "Em execução",
  concluida: "Concluído",
  cancelada: "Cancelado",
};

export const OPERACIONAL_STATUS_META = {
  rascunho: { label: "Aguardando envio", bg: "rgba(113,113,122,0.15)", color: "#a1a1aa" },
  aguardando_resposta_motorista: { label: "Aguardando motorista", bg: "rgba(234,179,8,0.12)", color: "#fde68a" },
  motorista_nao_respondeu: { label: "Motorista não respondeu", bg: "rgba(239,68,68,0.12)", color: "#fca5a5" },
  rota_enviada: { label: "Enviado ao motorista", bg: "rgba(59,130,246,0.12)", color: "#93c5fd" },
  assinaturas_em_andamento: { label: "Coletando assinaturas", bg: "rgba(59,130,246,0.12)", color: "#93c5fd" },
  em_rota: { label: "Van em rota", bg: "rgba(59,130,246,0.12)", color: "#93c5fd" },
  estimativas_planejadas: { label: "Previsões atualizadas", bg: "rgba(59,130,246,0.12)", color: "#93c5fd" },
  aguardando_km_final: { label: "Aguardando KM final", bg: "rgba(234,179,8,0.12)", color: "#fde68a" },
  finalizada: { label: "Concluído", bg: "rgba(34,197,94,0.12)", color: "#86efac" },
  falha: { label: "Falha na operação", bg: "rgba(239,68,68,0.12)", color: "#fca5a5" },
  enviada: { label: "Enviado ao motorista", bg: "rgba(34,197,94,0.12)", color: "#86efac" },
};

export const getPedidoStatusLabel = (item) => {
  if (!item) return "—";
  if (item.status === "planejada") {
    const rotaStatus = String(item.rota_status || "");
    if (rotaStatus === "planejamento") return "Aguardando confirmação";
    if (rotaStatus === "rascunho") return "Pronto para enviar";
    if (rotaStatus === "enviada") return "Em operação";
    return PEDIDO_STATUS_LABELS.planejada;
  }
  return PEDIDO_STATUS_LABELS[item.status] || String(item.status || "—").replace(/_/g, " ");
};

export const getOperacionalStatusMeta = (status) => (
  OPERACIONAL_STATUS_META[status] || {
    label: String(status || "Sem status").replace(/_/g, " "),
    bg: "var(--s3)",
    color: "var(--muted)",
  }
);

export const isManualRoute = (route) => {
  if (route?.lote_operacional_id) return false;
  const groups = Array.isArray(route?.payload?.grupos) ? route.payload.grupos : [];
  if (!groups.length) return true;
  return !groups.some((group) => (
    group?.programacao_responsavel_id || group?.programacao_codigo_responsavel
  ));
};

export const getRoutePedidoCodes = (route) => {
  const codes = new Set();
  if (route?.id_pedido) {
    String(route.id_pedido)
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean)
      .forEach((code) => codes.add(code));
  }
  for (const group of route?.payload?.grupos || []) {
    if (group?.programacao_codigo_responsavel) {
      codes.add(String(group.programacao_codigo_responsavel));
    }
  }
  return [...codes];
};
